module.exports = __webpack_public_path__ + "static/img/chance.9e0f28f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/chance.png
// module id = /0Ag
// module chunks = 2